import { Box, Button, Grid, Tooltip, Backdrop, CircularProgress } from '@mui/material';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';
import Header from './header';
import { ReportContextProvider, useReportContext } from './ReportContext';
import { useState, useEffect, useMemo, useRef } from 'react';
import DbExportButton from './DBExportButton';
import { LocalPrintshop } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import ActionItems from './actionItems';

const ReportsPageContent = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [includeOpeningBalance, setIncludeOpeningBalance] = useState(true);
  const { loading, reportData } = useReportContext();
  const { id } = useParams();
  console.log(id, 'id');

  console.log(reportData, 'reportData?.allAccounts');
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);
  // Read includeOpeningBalance from URL on mount and when URL changes
  const setoffValuesRef = useRef({});
  useEffect(() => {
    const includeOpeningBalanceParam = searchParams.get('includeOpeningBalance');
    if (includeOpeningBalanceParam !== null) {
      const value = includeOpeningBalanceParam === 'true';
      setIncludeOpeningBalance(value);
    }
  }, [searchParams]);
  const handleIncludeOpeningBalanceChange = (value) => {
    setIncludeOpeningBalance(value);
    const newParams = new URLSearchParams(searchParams);
    newParams.set('includeOpeningBalance', value.toString());
    setSearchParams(newParams, { replace: true });
  };

  // Calculate actionPeriod and outstandingPeriod based on id and dashboardData
  // Use useMemo to recalculate when id or dashboardData changes
  const actionPeriod = useMemo(() => {
    if (id === '7' && dashboardData['bsPeriod']?.startTimeStamp) {
      return dashboardData['bsPeriod'].range;
    }
    if (id === '5') {
      return 'quarter';
    }
    // if (dashboardData['report']?.period) {
    //   return dashboardData['report'].period;
    // }

    return 'month';
  }, [id, dashboardData]);
  console.log(dashboardData['report'], "dashboardData['report']");

  const outstandingPeriod = useMemo(() => {
    if (id === '7' && dashboardData['bsPeriod']?.startTimeStamp) {
      return dashboardData['bsPeriod'].range;
    }
    if (id === '7') {
      return 'day';
    }
    return null;
  }, [id, dashboardData]);

  const idsParam = searchParams.get('ids');
  const selectedIdsOrder = useMemo(() => {
    return idsParam
      ? decodeURIComponent(idsParam)
          .split(',')
          .filter(Boolean)
          .map((id) => id.trim())
          .reverse() // Reverse to show last selected first
      : [];
  }, [idsParam]);
  // const selectAcc = reportData.allAccounts.filter((dat) => dat.accountsid.includes(selectedIdsOrder));

  const selectAcc = useMemo(() => {
    return reportData?.allAccounts?.filter((dat) => selectedIdsOrder.includes(String(dat?.accountsid)));
  }, [reportData?.allAccounts, selectedIdsOrder]);
  console.log(selectedIdsOrder, selectAcc, 'selectedIdsOrder');
  const { startTimeStamp, endTimeStamp } = dashboardData?.report;
  return (
    <Box sx={{ width: '100%', overflowX: 'hidden' }}>
      <Header />
      <Grid
        container
        // spacing={2}
        sx={{
          marginTop: 2,
          width: '100%',
          maxWidth: '100%',
          paddingRight: { xs: 2, md: 0 },
          marginLeft: 4,
        }}
      >
        <Grid item xs={12} sm={4} md={id === '7' ? 7 : 5}>
          <ActionItems
            key={id} // Force remount when id changes to ensure fresh state
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            title={id === '7' ? 'Report As On' : 'Period'}
            page={'report'}
            actionPeriod={actionPeriod}
            outstandingPeriod={outstandingPeriod}
            showDateRangeText={true}
            openingBalanceRequired={id == 1 || id == 2 || id == 3 || id == 9}
            includeOpeningBalance={includeOpeningBalance}
            setIncludeOpeningBalance={handleIncludeOpeningBalanceChange}
          />
        </Grid>
        <Grid item xs={false} sm={false} md={id === '7' ? 3.5 : 5.5}></Grid>
        {idsParam && (
          <Grid item xs={12} sm={8} md={1.5}>
            <Box
              className="DbTools"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap',
                pr: { xs: '0px', sm: '20px' },
                m: { xs: 0, sm: 1 },
                gap: '5px',
                width: { xs: '100%', md: 'auto' },
              }}
            >
              <Tooltip title="Print" arrow>
                <Button
                  disableRipple
                  disableElevation
                  variant="outlined"
                  sx={{
                    // backgroundColor: 'bodyGray.main',
                    fontSize: { xs: '9px', sm: '10px' },
                    border: '1px solid',
                    borderColor: 'bodyGray.main',
                    boxShadow: `
                        inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
                        0 0 0 1px hsla(0, 0%, 0%, 0.05),
                        0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
                        0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
                        0 3.5px 6px hsla(0, 0%, 0%, 0.09)
                      `,
                    minWidth: { xs: '12px', sm: '15px', md: '25px' },
                    height: { xs: '26px', sm: '30px' },
                    backgroundColor: '#f9f9fe',
                  }}
                >
                  <LocalPrintshop sx={{ fontSize: { xs: '18px', sm: '24px' } }} />
                </Button>
              </Tooltip>
              <DbExportButton
                startDate={startTimeStamp}
                endDate={endTimeStamp}
                selectedTab={id}
                includeOpeningBalance={includeOpeningBalance}
                selectedAccount={selectAcc}
                getSetoffValues={() => setoffValuesRef.current}
              />
            </Box>
          </Grid>
        )}
      </Grid>
      <Box sx={{ width: '100%', overflowX: 'hidden', maxWidth: '100%' }}>
        <Outlet />
      </Box>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

const ReportsPage = () => {
  return (
    <ReportContextProvider>
      <ReportsPageContent />
    </ReportContextProvider>
  );
};

export default ReportsPage;
